// extracted by mini-css-extract-plugin
export default {"noResult":"autocompleteList_noResult__YZXg+","item":"autocompleteList_item__1MMws"};